/*
 * es-iab-nav-fallback.js
 * ─────────────────────────────────────────────────────────────────────────
 * Navigatie-vangnet voor in-app browsers (Instagram, Facebook, TikTok).
 *
 * SYMPTOOM
 * In de Instagram-browser op Android reageert geen enkele interne link. Je
 * ziet de tik wel (de :active-stijl licht op), maar er wordt niet
 * genavigeerd. In Chrome op datzelfde toestel en op iOS werkt alles.
 *
 * TWEE MOGELIJKE OORZAKEN, DIT DEKT ZE ALLEBEI
 *  1. Een beforeunload-listener dwingt de WebView door de unload-prompt-flow,
 *     die door de host-app verkeerd wordt afgehandeld en de navigatie
 *     stilzwijgend annuleert. Die listener is inmiddels weg uit
 *     es-page-transitions.js, dus dit zou al opgelost moeten zijn.
 *  2. Instagram injecteert eigen tracking-JavaScript in elke pagina en dat
 *     eet de standaard link-activatie op. Daar kunnen we niet bij.
 *
 * AANPAK
 * Bij een tik op een interne link zetten we een timer van 400ms. Start er een
 * echte navigatie, dan annuleert pagehide de timer en gebeurt er niets
 * extra's. Gebeurt er niets, dan forceren we de navigatie via location.href.
 *
 * WAAROM GEEN CHECK OP defaultPrevented
 * Oorzaak 2 werkt juist via preventDefault. Zouden we daarop annuleren, dan
 * schakelt het vangnet zichzelf uit op het moment dat het nodig is. In plaats
 * daarvan sluiten we de gebieden uit waar het thema links bewust zelf
 * afhandelt, zie SKIP_CONTAINERS.
 */
(function () {
  'use strict';

  window.__esNavFallback = true;   // zodat de diagnostiek kan zien dat dit draait

  /* Containers waar links via AJAX of eigen JS worden afgehandeld. Tikken
     daarbinnen mogen nooit een echte navigatie forceren, anders wordt
     bijvoorbeeld filteren op de collectiepagina een volledige herlaadbeurt. */
  var SKIP_CONTAINERS = [
    'facet-filters-form',
    '.facets',
    '.mobile-facets',
    '.es-facets',
    '[data-es-facets]',
    'predictive-search',
    'localization-form',
    '.es-card-carousel',
    '.es-product-gallery',
    '.es-pdp-tabs',
    'details-modal',
    '[data-no-nav-fallback]'
  ].join(',');

  var DELAY = 400;   // ms wachten op een echte navigatie
  var JITTER = 12;   // px vingerbeweging waarbinnen het nog een tik is

  var startX = 0, startY = 0, moved = 0;
  var timer = null;
  var laatsteLink = null, laatsteTik = 0;

  function cancel() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function isInternalNav(a) {
    if (!a || !a.getAttribute) return false;
    if (a.hasAttribute('download')) return false;
    if (a.getAttribute('target')) return false;              // _blank etc.
    if (a.hasAttribute('data-open-slide')) return false;      // opent een subslide
    if (a.hasAttribute('data-go-back')) return false;
    if (a.hasAttribute('data-no-nav-fallback')) return false;
    if (a.closest && a.closest(SKIP_CONTAINERS)) return false; // AJAX-gebied

    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|javascript:|sms:|whatsapp:)/i.test(href)) return false;

    try {
      var u = new URL(a.href, window.location.href);
      if (u.origin !== window.location.origin) return false;
      if (u.href === window.location.href) return false;      // zelfde pagina
      if (u.pathname.indexOf('/cart/') === 0) return false;    // cart-acties
      if (u.pathname.indexOf('/checkout') === 0) return false;
    } catch (e) { return false; }
    return true;
  }

  document.addEventListener('touchstart', function (e) {
    if (!e.touches || !e.touches.length) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    moved = 0;
    cancel();
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!e.touches || !e.touches.length) return;
    var d = Math.abs(e.touches[0].clientX - startX) + Math.abs(e.touches[0].clientY - startY);
    if (d > moved) moved = d;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (moved > JITTER) return;                 // dit was scrollen
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href]');
    if (!isInternalNav(a)) return;

    var href = a.href;
    laatsteLink = a;
    laatsteTik = Date.now();
    cancel();
    timer = setTimeout(function () {
      timer = null;
      // Nog steeds hier, dus de browser heeft de navigatie ingeslikt.
      window.location.href = href;
    }, DELAY);
  }, { passive: true });

  /* Tweede, sterkere net: navigeer SYNCHROON binnen de klik.
   *
   * De timer hierboven vuurt buiten het user gesture. Een Android WebView
   * krijgt dan hasGesture=false in shouldOverrideUrlLoading, en in-app
   * browsers blokkeren zulke navigatie standaard om redirect-kaping tegen te
   * gaan. Dit net draait binnen de klik zelf, dus met gesture.
   *
   * We roepen bewust GEEN preventDefault aan. Werkt de normale link gewoon,
   * dan navigeren browser en wij naar precies dezelfde URL en merkt niemand
   * er iets van. Wordt de standaardactie opgegeten, dan pakt deze het op.
   * Zo kan dit script nooit iets slopen dat het zonder hem wel deed.
   *
   * Capture-fase, zodat we vóór eventuele geinjecteerde handlers draaien. */
  document.addEventListener('click', function (e) {
    if (!laatsteLink) return;
    if (Date.now() - laatsteTik > 900) return;      // alleen vlak na een tik
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest('a[href]');
    if (!a || a !== laatsteLink) return;
    if (!isInternalNav(a)) return;
    var href = a.href;
    laatsteLink = null;
    cancel();
    window.location.href = href;
  }, true);

  /* Echte navigatie gestart, vangnet niet meer nodig.
     BEWUST GEEN beforeunload: precies zo'n listener is de vermoedelijke
     oorzaak van deze bug. pagehide doet hier hetzelfde werk. */
  window.addEventListener('pagehide', cancel);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') cancel();
  });
})();
